const HEIGHTS = { sm: "h-10", md: "h-12", lg: "h-20", xl: "h-24" };

export const Logo = ({ light = false, size = "md", className = "" }) => (
  <img
    src={light ? "/logo_light.png" : "/logo_dark.png"}
    alt="Briars Unlimited"
    data-testid="brand-logo"
    className={`${HEIGHTS[size] || HEIGHTS.md} w-auto object-contain ${className}`}
  />
);
